import { gql } from '@apollo/client';
import {
  sharedInvoiceInput,
  sharedInvoiceInputFields,
} from '../../fragments/invoice-input';
import MoneyFields from '../../fragments/money/money-fields';
import MasterEntityMinimalFields from '../../fragments/master-entity/master-entity-minimal-fields';
import InvoiceDteTypeMinimalFields from '../../fragments/invoice-dte-type/invoice-dte-type-minimal-fields';
import CompanyEvaluationRestrictionMinimalFields from '../../fragments/company-evaluation-restriction/company-evaluation-restriction-minimal-fields';
import ReferenceFields from '../../fragments/invoice/reference-fields';
import ExecutiveFields from '../../fragments/user/executive-fields';
import NoteFields from '../../fragments/invoice/note-fields';
import { sharedConnectionInputFields, sharedConnectionInput } from '../../fragments/connection-input';
import { InvoiceReviewDocumentsFields } from '../../fragments/invoice/invoice-review-documents-fields';

const EVALUATING_FACTORING = gql`
  query evaluatingFactoring(${sharedInvoiceInputFields}, ${sharedConnectionInputFields}) {
    invoices(${sharedInvoiceInput}, ${sharedConnectionInput}) {
      totalCount
      edges {
        cursor
        node {
          id
          folio
          dateIssued
          siiStatus
          loanedStatus
          loanedToRut
          loanedTo
          creditNoteStatus
          isForOrdering
          hasPaymentsEmitted
          status
          amountWithIva {
            ...MoneyFields
          }
          dteType {
            ...InvoiceDteTypeMinimalFields
          }
          company {
            id
            executiveAssigned {
              ...ExecutiveFields
            }
          }
          receiver {
            ...MasterEntityMinimalFields
          }
          preoffer {
            id
            monthlyRate
            defaultRate
            preofferevaluationrequest {
              id
              status
            }
          }
          offer {
            id
            transferCondition
          }
          operation {
            id
          }
          restrictedBy {
            ...CompanyEvaluationRestrictionMinimalFields
          }
          references {
            ...ReferenceFields
          }
          creditNotes @client {
            ...NoteFields
          }
          debitNotes @client {
            ...NoteFields
          }
          preofferSelectable @client
          ...InvoiceReviewDocumentsFields
        }
      }
    }
  }
  ${MoneyFields}
  ${MasterEntityMinimalFields}
  ${InvoiceDteTypeMinimalFields}
  ${CompanyEvaluationRestrictionMinimalFields}
  ${ReferenceFields}
  ${ExecutiveFields}
  ${NoteFields}
  ${InvoiceReviewDocumentsFields}
`;

export default EVALUATING_FACTORING;
